import { StandardLayout } from "common/layouts/StandardLayout";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { AdminDashboard } from "../AdminDashboard";
import { AdminExperiments } from "../AdminExperiments";
import { DeviceAnalytics } from "../DeviceAnalytics";
import { ExperiencesLookup } from "../ExperiencesLookup";

const Wrapper = ({ children }) => <StandardLayout greyBg>{children}</StandardLayout>;

export const routes = ({ match: { path } }) => (
  <Wrapper>
    <Switch>
      <Route path={`${path}/dashboard`} component={AdminDashboard} />
      <Route path={`${path}/experiments`} component={AdminExperiments} />
      <Route path={`${path}/device_analytics`} component={DeviceAnalytics} />
      <Route path={`${path}/experiences/lookup`} component={ExperiencesLookup} />
    </Switch>
  </Wrapper>
);
